// src/lib/exportExcel.js
export const exportSchedulesToExcel = async (items, filename = 'rozklad.xlsx') => {
  if (!items || items.length === 0) {
    alert('Немає даних для експорту');
    return;
  }

  // Динамічно підтягуємо бібліотеку (окремий чанк)
  const XLSX = await import('xlsx');

  // Унікальні групи
  const groups = [...new Set(items.map(s => s.group_name))].sort();

  // Унікальні комбінації (дата + пара)
  const slots = [...new Set(items.map(s => `${s.date}__${s.time_slot}`))]
    .map(key => {
      const [date, time_slot] = key.split('__');
      return { date, time_slot };
    })
    .sort(
      (a, b) =>
        new Date(a.date) - new Date(b.date) ||
        a.time_slot.localeCompare(b.time_slot)
    );

  // Формуємо шапку
  const header = ['Дата', 'Пара', ...groups];

  // Формуємо рядки
  const rows = slots.map(slot => {
    const row = [slot.date, slot.time_slot];
    groups.forEach(group => {
      const lesson = items.find(
        s =>
          s.date === slot.date &&
          s.time_slot === slot.time_slot &&
          s.group_name === group
      );
      row.push(
        lesson ? `${lesson.subject}${lesson.room ? ' (' + lesson.room + ')' : ''}` : ''
      );
    });
    return row;
  });

  // Створюємо аркуш
  const ws = XLSX.utils.aoa_to_sheet([header, ...rows]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Розклад');

  XLSX.writeFile(wb, filename);
};
